import { useMediaQuery } from '@chakra-ui/react';
const useScreenSize = () => {
    const [isLessThan768] = useMediaQuery(['(max-width: 768px)'], { ssr: false });
    return {
        isLessThan768
    };
};
export { useScreenSize };
//# sourceMappingURL=useScreenSize.js.map